module.exports = __webpack_public_path__ + "images/pro/payment-cortransfer-6b96bf24bb192457279fda34502b7771.png";